import { CurrencyCode } from 'further-types/lp/vehicle';
import { type Column as TableColumn } from 'further-ui/components/Table';
import { CalendarDay, numberToCurrencyString } from 'further-ui/utils';
import type { TrialBalanceRow } from 'further-types/lp/general-ledger';

type TrialBalanceRowWithId = TrialBalanceRow & {
  id: string;
};

const getColumns = (
  baseCurrency: CurrencyCode,
  isGroupByGlAccount: boolean,
  yearEndDate?: CalendarDay,
): Array<TableColumn<TrialBalanceRowWithId>> => [
  {
    key: 'code',
    label: 'Code',
    textOverflowEllipsis: true,
    width: 40,
  },
  ...(!isGroupByGlAccount
    ? [
        {
          key: 'transactionType',
          label: 'Transaction type',
          textOverflowEllipsis: true,
          width: 120,
        },
      ]
    : []),
  {
    key: 'accountName',
    label: 'Account',
    textOverflowEllipsis: true,
    width: 120,
  },
  {
    key: 'accountType',
    label: 'Account type',
    textOverflowEllipsis: true,
    width: 90,
  },

  {
    key: 'startingBalance',
    label: 'Starting balance',
    textOverflowEllipsis: true,
    width: 120,
    render: ({ startingBalance }) =>
      numberToCurrencyString(startingBalance, {
        currency: baseCurrency,
        negativeInBrackets: true,
      }),
  },
  {
    key: 'debitsYtd',
    label: 'Debits (YTD)',
    textOverflowEllipsis: true,
    width: 110,
    render: ({ debitsYtd }) =>
      numberToCurrencyString(debitsYtd, {
        currency: baseCurrency,
        negativeInBrackets: true,
      }),
  },
  {
    key: 'creditsYtd',
    label: 'Credits (YTD)',
    textOverflowEllipsis: true,
    width: 110,
    render: ({ creditsYtd }) =>
      numberToCurrencyString(creditsYtd, {
        currency: baseCurrency,
        negativeInBrackets: true,
      }),
  },
  {
    key: 'change',
    label: 'Changes',
    textOverflowEllipsis: true,
    width: 120,
    render: ({ change }) =>
      numberToCurrencyString(change, {
        currency: baseCurrency,
        negativeInBrackets: true,
      }),
  },
  {
    key: 'balance',
    label: `Balance ${yearEndDate?.toLabel() ?? ''}`.trim(),
    textOverflowEllipsis: true,
    width: 120,
    render: ({ balance }) =>
      numberToCurrencyString(balance, {
        currency: baseCurrency,
        negativeInBrackets: true,
      }),
  },
];

export default getColumns;
